import React, { useEffect } from 'react';
import Page from 'Views/Page';
import { PassthroughIdentityChallengeContext } from 'Context/IdentityChallengeContext/passthrough';
import { DebugProvider } from 'Context/DebugContext';
import useEventTrackingIdentify from 'EventTracking/useEventTrackingIdentify';
import fr from 'facet-rest';
import useHomeContext from 'Context/HomeContext';
import { initializeSegment, teardownSegment } from 'EventTracking/Vendors/Segment';
import { teardownGoogleAnalytics } from 'EventTracking/Vendors/GoogleAnalytics';

export function BuyPage() {
  const identify = useEventTrackingIdentify();
  useEffect(() => {
    identify(undefined, {});
  }, [identify]);

  // If you're logged in and you access C2B, when you finish, you'll get an error page if it was successful because EnforceHouseholdID will notice it
  const { homeResource } = useHomeContext();
  useEffect(() => {
    if (homeResource.relationship(fr.relationships.user.name)) {
      window.location = '/'; // The user is logged in, they can't access this page. Stop them.
    }
  }, [homeResource]);

  useEffect(() => {
    // If somehow google analytics has been enabled on this page it must be torn down
    // We don't expect this should be true, but this is a stopgap just in case it
    // was erroneously initialized
    teardownGoogleAnalytics();

    // We need segment on this page even though we don't need google analytics. When the page is unmounted, teardown segment.
    initializeSegment();
    return () => {
      teardownSegment();
    };
  }, []);

  return (
    <PassthroughIdentityChallengeContext>
      <DebugProvider initialState={null}>
        <Page />
      </DebugProvider>
    </PassthroughIdentityChallengeContext>
  );
}
